// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__DSWwr","clinicsSelect":"styles_clinicsSelect__1vnqO"};